import { render } from "./vcoursewareclassifyedit.vue?vue&type=template&id=3615453d&scoped=true"
import script from "./vcoursewareclassifyedit.vue?vue&type=script&lang=js"
export * from "./vcoursewareclassifyedit.vue?vue&type=script&lang=js"

import "./vcoursewareclassifyedit.vue?vue&type=style&index=0&id=3615453d&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境租户后台rent.syinba.com/jsvueweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3615453d"]])

export default __exports__